// extracted by mini-css-extract-plugin
export default {"home_container":"homepage_home_container__9gwTx","text_container":"homepage_text_container__kHijf","alert_container":"homepage_alert_container__6v-RQ"};